import React, { ReactElement, useRef, useState } from 'react'
import Immutable from 'immutable'
import cc from 'classcat'
import loadable from '@loadable/component'

import compose from '../../../../../utils/compose'
import translate from '../../../../../utils/translate'
import withI18n from '../../../../withI18n'

const SettingsLayer = loadable(() => import(/* webpackChunkName: "editor" */ '../../SettingsLayer'))
const SettingsForm = loadable(() => import(/* webpackChunkName: "editor" */ './DividerSettings'))

function DividerPlugin({
  data = Immutable.fromJS({ dividerType: 'solid' }),
  editorMode,
  editorView,
  onCancel,
  onDataChange,
  onSave,
}: WorkspacePluginProps & TranslateProps): ReactElement | null {
  const [isSettingActive, setIsSettingActive] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const dividerType = data.get('dividerType')

  const pluginActiveClasses = cc([
    'dali-plugin-divider',
    {
      'dali-grid-element-hightlighted': isSettingActive,
    },
  ])

  const divider = <hr style={{ borderStyle: dividerType }} />

  const renderSettingsLayer = () => {
    return (
      <SettingsLayer
        referenceElement={ref.current}
        placement="right"
        onActiveStateChange={(isSettingActive: boolean) => setIsSettingActive(isSettingActive)}
        onEscapeKeyDown={onCancel}
      >
        {({ renderLayout }) => <SettingsForm {...{ data, onDataChange, onSave, onCancel, renderLayout }} />}
      </SettingsLayer>
    )
  }

  if (editorView) {
    return (
      <div className={pluginActiveClasses} ref={ref}>
        {divider}
        {editorMode === 'edit' ? renderSettingsLayer() : null}
      </div>
    )
  }

  return !dividerType ? null : <div className={pluginActiveClasses}>{divider}</div>
}

DividerPlugin.actionBarButtons = { edit: true }

export default compose(withI18n('interface'), translate())(DividerPlugin)
